import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useCurrentBreakpoint = () => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const isXXl = useMediaQuery(theme.breakpoints.up('xxl'));

  if (isXXl) return 'xxl';
  if (isXl) return 'xl';
  if (isLg) return 'lg';
  if (isSm) return 'sm';
  return 'xs';
};
